export function normalizeCustomer(input) {
  const source = input || {};
  const regularRaw = source.PravidelnyZakaznik ?? source.pravidelnyZakaznik;

  const isRegularCustomer =
    regularRaw === true ||
    String(regularRaw || '').trim().toLowerCase() === 'true';

  return {
    ZakaznikId: Number(source.ZakaznikId || source.zakaznikId || source.ID || 0),
    Nazev: asString(source.Nazev || source.nazev || source.Name || source.name),
    Ulice: asString(source.Ulice || source.ulice || source.Address || source.address),
    ZakaznikFA: asString(source.ZakaznikFA || source.zakaznikFA),
    UliceFA: asString(source.UliceFA || source.uliceFA),
    IC: asString(source.IC || source.Ico || source.ico || source.ICO),
    DIC: asString(source.DIC || source.dic),
    KontaktniOsoba: asString(source.KontaktniOsoba || source.kontaktniOsoba || source.Kontakt),
    Telefon: asString(source.Telefon || source.telefon || source.Tel || source.Phone),
    Email: asString(source.Email || source.email || source.Mail),
    ZakaznikGuid: asString(source.ZakaznikGuid || source.ZakaznikGuiD || source.zakaznikGuid),
    Technik_Jmeno: asString(source.Technik_Jmeno || source.technik_Jmeno),
    Technik_Prijmeni: asString(source.Technik_Prijmeni || source.technik_Prijmeni),
    Technik_Telefon: asString(source.Technik_Telefon || source.technik_Telefon),
    Technik_Email: asString(source.Technik_Email || source.technik_Email),
    Dny: toNumber(source.Dny || source.dny),
    Latitude: toNumber(source.Latitude || source.latitude),
    Longitude: toNumber(source.Longitude || source.longitude),
    EAN: asString(source.EAN || source.ean),
    PravidelnyZakaznik: isRegularCustomer,
    HACCP: toBoolean(source.HACCP || source.haccp),
    Poznamka: asString(source.Poznamka || source.poznamka),
    Smlouva: toBoolean(source.Smlouva || source.smlouva),
  };
}

export function normalizeJob(input) {
  const source = input || {};
  return {
    ZakazkaId: Number(source.ZakazkaId || source.zakazkaId || source.ID || 0),
    ZakaznikId: Number(source.ZakaznikId || source.zakaznikId || 0),
    Datum: normalizeDate(source.Datum || source.datum || source.CreatedDate),
    ZamestnanecId: Number(source.ZamestnanecId || source.zamestnanecId || 0),
    FirmaId: Number(source.FirmaId || source.firmaId || 0),
    StatusId: Number(source.StatusId || source.statusId || 0),
    FakturaStatusId: Number(source.FakturaStatusId || source.fakturaStatusId || 0),
    ZpusobPlatbyId: Number(source.ZpusobPlatbyId || source.zpusobPlatbyId || 0),
    SkudceId: Number(source.SkudceId || source.skudceId || 0),
    CisloProtokolu: toNumber(source.CisloProtokolu || source.cisloProtokolu || source.ProtokolCislo || source.protokolCislo),
    ProtokolBlobUrl: asString(source.ProtokolBlobUrl || source.protokolBlobUrl),
    Doprava: toNumber(source.Doprava || source.doprava),
    CenaZakazky: toNumber(source.CenaZakazky || source.cenaZakazky),
    OstatniNaklady: toNumber(source.OstatniNaklady || source.ostatniNaklady),
    NazevZakazky: String(source.NazevZakazky || source.nazevZakazky || source.Nazev || 'Nova zakazka'),
    Poznamka: String(source.Poznamka || source.poznamka || source.Popis || source.popis || ''),
    Popis: String(source.Popis || source.popis || source.Poznamka || source.poznamka || ''),
    DatumNaplanovano: normalizeDate(source.Datum_naplanovano || source.datum_naplanovano || source.DatumNaplanovano || source.Datum || source.datum),
    Status: String(source.Status || source.status || source.StatusNazev || 'otevrena'),
    Priorita: asString(source.Priorita || source.priorita),
    Skudce: asString(source.Skudce || source.skudce || source.SkudceNazev),
    NazevZakaznika: asString(source.NazevZakaznika || source.Nazev || source.ZakaznikNazev),
    TechnikEmail: asString(source.TchnikEmail || source.TechnikEmail || source.ZamEmail || source.email),
  };
}

export function normalizeRegularInspection(input) {
  const source = input || {};
  return {
    ZakaznikId: toNumber(source.ZakaznikId || source.zakaznikId || source.ID),
    ZakaznikNazev: asString(source.ZakaznikNazev || source.zakaznikNazev || source.Nazev),
    Ulice: asString(source.Ulice || source.ulice || source.Address),
    Mesto: asString(source.Mesto || source.mesto || source.City),
    KontaktniOsoba: asString(source.KontaktniOsoba || source.kontaktniOsoba || source.Kontakt),
    Telefon: asString(source.Telefon || source.telefon || source.Phone),
    Email: asString(source.Email || source.email || source.Mail),
    PravidelnostNazev: asString(source.PravidelnostNazev || source.pravidelnostNazev),
    Poznamka: asString(source.Poznamka || source.poznamka),
    ZamestnanecId: toNumber(source.ZamestnanecId || source.zamestnanecId),
    ZamestnanecJmeno: asString(source.ZamestnanecJmeno || source.zamestnanecJmeno),
    ZamestnanecPrijmeni: asString(source.ZamestnanecPrijmeni || source.zamestnanecPrijmeni),
    ZamestnanecEmail: asString(source.ZamestnanecEmail || source.zamestnanecEmail),
    Aktivni: source.Aktivni === undefined ? true : source.Aktivni === true || source.Aktivni === 1 || source.Aktivni === '1',
    Dny: toNumber(source.Dny ?? source.dny),
    EAN: asString(source.EAN ?? source.ean),
    PosledniEANCheckTimeStamp: normalizeDate(source.PosledniEANCheckTimeStamp || source.posledniEANCheckTimeStamp),
    PosledniKontaktDatum: normalizeDate(source.PosledniKontaktDatum || source.posledniKontaktDatum),
    PuvodniPlanovanaKontrolaDatum: normalizeDate(source.PuvodniPlanovanaKontrolaDatum || source.puvodniPlanovanaKontrolaDatum),
    NovePlanovanaKontrolaDatum: normalizeDate(source.NovePlanovanaKontrolaDatum || source.novePlanovanaKontrolaDatum),
    DnyOdPoslednihoKontaktu: toNumber(source.DnyOdPoslednihoKontaktu || source.dnyOdPoslednihoKontaktu),
    StatusKontroly: asString(source.StatusKontroly || source.statusKontroly || source.Status),
    Status: toNumber(source.Status || source.status),
  };
}

function asString(value) {
  if (value === null || value === undefined) return null;
  const s = String(value).trim();
  return s.length ? s : null;
}

function normalizeDate(value) {
  const s = asString(value);
  if (!s) return null;
  const ten = s.slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(ten) ? ten : s;
}

function toNumber(value) {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function toBoolean(value) {
  if (typeof value === 'boolean') return value;
  if (value === null || value === undefined || value === '') return false;
  const text = String(value).trim().toLowerCase();
  return text === '1' || text === 'true';
}
